import React, { useEffect, useState } from "react";
import apiClient from "../../utils/apiclient";

const USE_MOCK_DELAYED_ORDERS = false;

const MOCK_DELAYED_ORDERS_DATA = {
  date: "2026-08-17",
  checkedAt: "22:55:00",
  totalDelayedOrders: 4,
  totalChefDelayedOrders: 4,
  totalRiderDelayedOrders: 0,
  overallOrders: [
    {
      orderId: 1500,
      publicId: "054239707",
      orderType: "SUBSCRIPTION",
      delayType: "CHEF_DELAY",
      status: "ordered",
      restaurantId: 50,
      restaurantName: "Test",
      startTime: "14:00:00",
      endTime: "15:00:00",
      customerId: 145,
      customerNumber: "9950902807",
    },
    {
      orderId: 1501,
      publicId: "688313835",
      orderType: "SUBSCRIPTION",
      delayType: "CHEF_DELAY",
      status: "ordered",
      restaurantId: 50,
      restaurantName: "Test",
      startTime: "14:00:00",
      endTime: "15:00:00",
      customerId: 145,
      customerNumber: "9950902807",
    },
    {
      orderId: 1502,
      publicId: "023542757",
      orderType: "SUBSCRIPTION",
      delayType: "CHEF_DELAY",
      status: "ordered",
      restaurantId: 50,
      restaurantName: "Test",
      startTime: "21:00:00",
      endTime: "22:00:00",
      customerId: 145,
      customerNumber: "9950902807",
    },
    {
      orderId: 1503,
      publicId: "745347770",
      orderType: "SUBSCRIPTION",
      delayType: "CHEF_DELAY",
      status: "ordered",
      restaurantId: 50,
      restaurantName: "Test",
      startTime: "21:00:00",
      endTime: "22:00:00",
      customerId: 145,
      customerNumber: "9950902807",
    },
  ],
  restaurantWise: [
    {
      restaurantId: 50,
      restaurantName: "Test",
      totalDelayedOrders: 4,
      chefDelayedOrders: 4,
      riderDelayedOrders: 0,
      orders: [
        {
          orderId: 1500,
          publicId: "054239707",
          orderType: "SUBSCRIPTION",
          delayType: "CHEF_DELAY",
          status: "ordered",
          restaurantId: 50,
          restaurantName: "Test",
          startTime: "14:00:00",
          endTime: "15:00:00",
          customerId: 145,
          customerNumber: "9950902807",
        },
        {
          orderId: 1501,
          publicId: "688313835",
          orderType: "SUBSCRIPTION",
          delayType: "CHEF_DELAY",
          status: "ordered",
          restaurantId: 50,
          restaurantName: "Test",
          startTime: "14:00:00",
          endTime: "15:00:00",
          customerId: 145,
          customerNumber: "9950902807",
        },
        {
          orderId: 1502,
          publicId: "023542757",
          orderType: "SUBSCRIPTION",
          delayType: "CHEF_DELAY",
          status: "ordered",
          restaurantId: 50,
          restaurantName: "Test",
          startTime: "21:00:00",
          endTime: "22:00:00",
          customerId: 145,
          customerNumber: "9950902807",
        },
        {
          orderId: 1503,
          publicId: "745347770",
          orderType: "SUBSCRIPTION",
          delayType: "CHEF_DELAY",
          status: "ordered",
          restaurantId: 50,
          restaurantName: "Test",
          startTime: "21:00:00",
          endTime: "22:00:00",
          customerId: 145,
          customerNumber: "9950902807",
        },
      ],
    },
  ],
};

const delayBadgeClass = (delayType) => {
  const normalized = String(delayType || "").toUpperCase();

  if (normalized === "CHEF_DELAY") {
    return "border-amber-200 bg-amber-50 text-amber-700";
  }

  if (normalized === "RIDER_DELAY") {
    return "border-red-200 bg-red-50 text-red-700";
  }

  return "border-gray-200 bg-gray-50 text-gray-700";
};

const statusBadgeClass = (status) => {
  const normalized = String(status || "").toLowerCase();

  if (normalized === "ordered") {
    return "border-blue-200 bg-blue-50 text-blue-700";
  }

  if (normalized === "in_progress" || normalized === "in-progress") {
    return "border-violet-200 bg-violet-50 text-violet-700";
  }

  if (normalized === "delivered") {
    return "border-green-200 bg-green-50 text-green-700";
  }

  return "border-gray-200 bg-gray-50 text-gray-700";
};

const Index = () => {
  const [delayedOrdersData, setDelayedOrdersData] = useState({
    totalDelayedOrders: 0,
    totalChefDelayedOrders: 0,
    totalRiderDelayedOrders: 0,
    overallOrders: [],
    restaurantWise: [],
  });
  const [loading, setLoading] = useState(true);
  const [expandedRestaurantId, setExpandedRestaurantId] = useState(null);
  const [downloadRestaurantId, setDownloadRestaurantId] = useState("all");

  useEffect(() => {
    const fetchDelayedOrders = async () => {
      try {
        const response = USE_MOCK_DELAYED_ORDERS
          ? { data: MOCK_DELAYED_ORDERS_DATA }
          : await apiClient.get("/delayed-orders");
        const payload = response?.data || {};

        setDelayedOrdersData({
          totalDelayedOrders: Number(payload.totalDelayedOrders || 0),
          totalChefDelayedOrders: Number(payload.totalChefDelayedOrders || 0),
          totalRiderDelayedOrders: Number(payload.totalRiderDelayedOrders || 0),
          overallOrders: Array.isArray(payload.overallOrders) ? payload.overallOrders : [],
          restaurantWise: Array.isArray(payload.restaurantWise) ? payload.restaurantWise : [],
        });
      } catch (error) {
        console.error("Failed to fetch delayed orders", error);
        setDelayedOrdersData({
          totalDelayedOrders: 0,
          totalChefDelayedOrders: 0,
          totalRiderDelayedOrders: 0,
          overallOrders: [],
          restaurantWise: [],
        });
      } finally {
        setLoading(false);
      }
    };

    fetchDelayedOrders();
  }, []);

  const overallGroup = {
    restaurantId: "overall",
    restaurantName: "Overall",
    totalDelayedOrders: delayedOrdersData.totalDelayedOrders,
    chefDelayedOrders: delayedOrdersData.totalChefDelayedOrders,
    riderDelayedOrders: delayedOrdersData.totalRiderDelayedOrders,
    orders: delayedOrdersData.overallOrders,
  };

  const restaurantGroups = delayedOrdersData.restaurantWise.length
    ? delayedOrdersData.restaurantWise
    : []; 

  const downloadOrdersAsExcel = () => {
    const selectedRestaurant = restaurantGroups.find(
      (restaurant) => String(restaurant.restaurantId) === downloadRestaurantId
    );
    const orders = downloadRestaurantId === "all"
      ? delayedOrdersData.overallOrders
      : (selectedRestaurant?.orders || []);

    if (!orders.length) {
      return;
    }

    const headers = [
      "Order ID",
      "Public ID",
      "Order Type",
      "Delay Type",
      "Status",
      "Restaurant ID",
      "Restaurant Name",
      "Start Time",
      "End Time",
      "Customer ID",
      "Customer Number",
    ];

    const escapeCell = (value) => {
      const text = value === null || value === undefined ? "" : String(value);
      return `"${text.replace(/"/g, '""')}"`;
    };

    const rows = orders.map((order) => [
      order.orderId,
      order.publicId,
      order.orderType,
      order.delayType,
      order.status,
      order.restaurantId,
      order.restaurantName,
      order.startTime,
      order.endTime,
      order.customerId,
      order.customerNumber,
    ].map(escapeCell).join(","));

    const csv = `\uFEFF${[headers.join(","), ...rows].join("\n")}`;
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    const restaurantName = selectedRestaurant?.restaurantName || "all-orders";
    const safeRestaurantName = restaurantName.replace(/[^a-z0-9]+/gi, "-").replace(/^-|-$/g, "").toLowerCase();

    link.href = url;
    link.download = `delayed-orders-${safeRestaurantName || "all-orders"}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <div className="p-4 md:p-6">
      <div className="mb-6 flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-orange-500">Operations</p>
          <h1 className="text-2xl font-bold text-gray-900">Delayed Orders</h1>
        </div>
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
          <div className="rounded-full border border-orange-200 bg-orange-50 px-3 py-1 text-sm font-medium text-orange-700">
            {delayedOrdersData.totalDelayedOrders} total delayed
          </div>
          <div className="flex gap-2">
            <select
              value={downloadRestaurantId}
              onChange={(event) => setDownloadRestaurantId(event.target.value)}
              disabled={loading || delayedOrdersData.overallOrders.length === 0}
              className="rounded border border-gray-300 bg-white px-2 py-1 text-sm text-gray-700 disabled:cursor-not-allowed disabled:bg-gray-100"
              aria-label="Select delayed orders export scope"
            >
              <option value="all">All Orders</option>
              {restaurantGroups.map((restaurant) => (
                <option key={restaurant.restaurantId} value={String(restaurant.restaurantId)}>
                  {restaurant.restaurantName || `Restaurant ${restaurant.restaurantId}`}
                </option>
              ))}
            </select>
            <button
              type="button"
              onClick={downloadOrdersAsExcel}
              disabled={loading || delayedOrdersData.overallOrders.length === 0}
              className="rounded bg-green-600 px-3 py-1 text-sm font-semibold text-white hover:bg-green-700 disabled:cursor-not-allowed disabled:bg-gray-400"
            >
              Download Excel
            </button>
          </div>
        </div>
      </div>

      <div className="mb-6 grid gap-4 md:grid-cols-3">
        <div className="rounded-2xl border border-amber-200 bg-amber-50 p-4 shadow-sm">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-amber-700">Chef Delay</div>
          <div className="mt-3 text-3xl font-bold text-amber-900">{delayedOrdersData.totalChefDelayedOrders}</div>
        </div>

        <div className="rounded-2xl border border-red-200 bg-red-50 p-4 shadow-sm">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-red-700">Rider Delay</div>
          <div className="mt-3 text-3xl font-bold text-red-900">{delayedOrdersData.totalRiderDelayedOrders}</div>
        </div>

        <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-600">Overall</div>
          <div className="mt-3 text-3xl font-bold text-slate-900">{delayedOrdersData.totalDelayedOrders}</div>
        </div>
      </div>

      {loading ? (
        <div className="rounded-xl border border-gray-200 bg-white p-6 text-sm text-gray-600 shadow-sm">
          Loading delayed orders...
        </div>
      ) : (
        <div className="space-y-4">
          <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
            <button
              type="button"
              onClick={() => setExpandedRestaurantId((prev) => (prev === "overall" ? null : "overall"))}
              className="flex w-full items-center justify-between gap-3 bg-orange-50 px-4 py-3 text-left hover:bg-orange-100"
            >
              <div>
                <div className="text-base font-bold text-gray-900">Overall Orders</div>
                <div className="mt-1 text-xs text-gray-600">
                  {overallGroup.totalDelayedOrders} delayed orders • {overallGroup.chefDelayedOrders} chef delay • {overallGroup.riderDelayedOrders} rider delay
                </div>
              </div>
              <span className="rounded-full border border-orange-200 bg-white px-2 py-1 text-xs font-medium text-orange-700">
                {expandedRestaurantId === "overall" ? "Hide" : "View"}
              </span>
            </button>

            {expandedRestaurantId === "overall" && (
              <div className="overflow-x-auto">
                <table className="min-w-full border-collapse text-left text-sm text-gray-700">
                  <thead className="bg-gray-900 text-white">
                    <tr>
                      <th className="px-4 py-3 font-semibold">Order</th>
                      <th className="px-4 py-3 font-semibold">Type</th>
                      <th className="px-4 py-3 font-semibold">Delay</th>
                      <th className="px-4 py-3 font-semibold">Status</th>
                      <th className="px-4 py-3 font-semibold">Time Slot</th>
                      <th className="px-4 py-3 font-semibold">Customer</th>
                    </tr>
                  </thead>
                  <tbody>
                    {overallGroup.orders.length ? (
                      overallGroup.orders.map((order) => (
                        <tr key={`${order.orderId ?? order.publicId ?? Math.random()}`} className="border-t border-gray-200 align-top hover:bg-gray-50">
                          <td className="px-4 py-3">
                            <div className="font-semibold text-gray-900">#{order.orderId ?? "-"}</div>
                            <div className="text-xs text-gray-500">Public ID: {order.publicId || "-"}</div>
                            <div className="text-xs text-gray-500">Restaurant: {order.restaurantName || "-"}</div>
                          </td>
                          <td className="px-4 py-3">
                            <span className="rounded-full border border-slate-200 bg-slate-50 px-2 py-1 text-xs font-medium text-slate-700">
                              {order.orderType || "-"}
                            </span>
                          </td>
                          <td className="px-4 py-3">
                            <span className={`rounded-full border px-2 py-1 text-xs font-semibold ${delayBadgeClass(order.delayType)}`}>
                              {order.delayType || "-"}
                            </span>
                          </td>
                          <td className="px-4 py-3">
                            <span className={`rounded-full border px-2 py-1 text-xs font-semibold ${statusBadgeClass(order.status)}`}>
                              {order.status || "-"}
                            </span>
                          </td>
                          <td className="px-4 py-3 text-xs text-gray-600">
                            <div>{order.startTime || "-"}</div>
                            <div>{order.endTime || "-"}</div>
                          </td>
                          <td className="px-4 py-3 text-xs text-gray-600">
                            <div className="font-medium text-gray-800">Customer ID: {order.customerId ?? "-"}</div>
                            <div>Customer Number: {order.customerNumber || "-"}</div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={6} className="px-4 py-6 text-center text-sm text-gray-500">
                          No overall delayed orders found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          {restaurantGroups.length ? (
            restaurantGroups.map((restaurant) => {
              const restaurantId = restaurant.restaurantId ?? "overall";
              const isExpanded = expandedRestaurantId === restaurantId;
              const restaurantOrders = Array.isArray(restaurant.orders) ? restaurant.orders : [];

              return (
                <div key={restaurantId} className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
                  <button
                    type="button"
                    onClick={() => setExpandedRestaurantId(isExpanded ? null : restaurantId)}
                    className="flex w-full items-center justify-between gap-3 bg-gray-50 px-4 py-3 text-left hover:bg-gray-100"
                  >
                    <div>
                      <div className="text-base font-bold text-gray-900">{restaurant.restaurantName || "Restaurant"}</div>
                      <div className="mt-1 text-xs text-gray-500">
                        {restaurant.totalDelayedOrders ?? restaurantOrders.length} delayed orders • {restaurant.chefDelayedOrders ?? 0} chef delay • {restaurant.riderDelayedOrders ?? 0} rider delay
                      </div>
                    </div>
                    <span className="rounded-full border border-gray-300 bg-white px-2 py-1 text-xs font-medium text-gray-700">
                      {isExpanded ? "Hide" : "View"}
                    </span>
                  </button>

                  {isExpanded && (
                    <div className="overflow-x-auto">
                      <table className="min-w-full border-collapse text-left text-sm text-gray-700">
                        <thead className="bg-gray-900 text-white">
                          <tr>
                            <th className="px-4 py-3 font-semibold">Order</th>
                            <th className="px-4 py-3 font-semibold">Type</th>
                            <th className="px-4 py-3 font-semibold">Delay</th>
                            <th className="px-4 py-3 font-semibold">Status</th>
                            <th className="px-4 py-3 font-semibold">Time Slot</th>
                            <th className="px-4 py-3 font-semibold">Customer</th>
                          </tr>
                        </thead>
                        <tbody>
                          {restaurantOrders.length ? (
                            restaurantOrders.map((order) => (
                              <tr key={`${order.orderId ?? order.publicId ?? Math.random()}`} className="border-t border-gray-200 align-top hover:bg-gray-50">
                                <td className="px-4 py-3">
                                  <div className="font-semibold text-gray-900">#{order.orderId ?? "-"}</div>
                                  <div className="text-xs text-gray-500">Public ID: {order.publicId || "-"}</div>
                                  <div className="text-xs text-gray-500">Restaurant: {order.restaurantName || "-"}</div>
                                </td>
                                <td className="px-4 py-3">
                                  <span className="rounded-full border border-slate-200 bg-slate-50 px-2 py-1 text-xs font-medium text-slate-700">
                                    {order.orderType || "-"}
                                  </span>
                                </td>
                                <td className="px-4 py-3">
                                  <span className={`rounded-full border px-2 py-1 text-xs font-semibold ${delayBadgeClass(order.delayType)}`}>
                                    {order.delayType || "-"}
                                  </span>
                                </td>
                                <td className="px-4 py-3">
                                  <span className={`rounded-full border px-2 py-1 text-xs font-semibold ${statusBadgeClass(order.status)}`}>
                                    {order.status || "-"}
                                  </span>
                                </td>
                                <td className="px-4 py-3 text-xs text-gray-600">
                                  <div>{order.startTime || "-"}</div>
                                  <div>{order.endTime || "-"}</div>
                                </td>
                                <td className="px-4 py-3 text-xs text-gray-600">
                                  <div className="font-medium text-gray-800">Customer ID: {order.customerId ?? "-"}</div>
                                  <div>Customer Number: {order.customerNumber || "-"}</div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={6} className="px-4 py-6 text-center text-sm text-gray-500">
                                No orders in this restaurant group.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              );
            })
          ) : null}
        </div>
      )}
    </div>
  );
};

export default Index;
